export default "__VITE_ASSET__d0Wq8JGI__"